export const SearchBar = () => {
  return <div>SearchBar</div>;
};
